import ScreenviewCondition from 'cio/app-models/conditions/screenview';
import refinement from './refinement';
import { SerializedScreenviewCondition } from 'cio/types/conditions/condition';
import { deserializeFilters, filterOperator } from 'cio/utils/conditions/deserialize/event';

export default function (json: SerializedScreenviewCondition) {
  let event = json.event || {};
  let { times, within, inverse } = json;
  let anyScreen = event.name === '*';
  let name = null;

  if (!anyScreen) {
    name = event.name;
  }

  return ScreenviewCondition.create({
    name,
    anyScreen,
    inverse,
    refinement: refinement(times, Number(within)),
    filters: deserializeFilters(event?.filters, event.name),
    filterOperator: filterOperator(event?.filters),
  });
}
